<template>
  <div class="accounts">
    <h1>账号管理</h1>

    <el-card>
      <template #header>
        <div class="card-header">
          <span>账号列表</span>
          <div>
            <el-select v-model="filterPlatform" size="small" style="width: 110px; margin-right: 8px" @change="loadAccounts()">
              <el-option label="全部平台" value="" />
              <el-option label="抖音" value="douyin" />
              <el-option label="快手" value="kuaishou" />
            </el-select>
            <el-button type="primary" @click="showAddDialog = true">
              添加账号
            </el-button>
          </div>
        </div>
      </template>

      <el-table :data="accounts" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="平台" width="90">
          <template #default="scope">
            <el-tag :type="scope.row.platform === 'kuaishou' ? 'warning' : ''" size="small">
              {{ platformText(scope.row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="抖音号" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column label="行业" width="190">
          <template #default="scope">
            <div style="display:flex;align-items:center;gap:2px">
              <el-select
                v-if="indEditingId === scope.row.id"
                v-model="scope.row.industry" filterable size="small" style="width:130px"
                placeholder="选行业" @change="saveRowIndustry(scope.row)"
              >
                <el-option v-for="n in industries" :key="n" :label="n" :value="n" />
              </el-select>
              <template v-else>
                <el-tag v-if="scope.row.industry" size="small" type="success">{{ scope.row.industry }}</el-tag>
                <el-tag v-else size="small" type="info">未设置</el-tag>
                <el-button size="small" text type="primary" title="设置行业" @click="indEditingId = scope.row.id">✏️</el-button>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ statusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_logged_in" label="登录状态">
          <template #default="scope">
            <el-tag :type="scope.row.is_logged_in ? 'success' : 'info'">
              {{ scope.row.is_logged_in ? '✅ 已登录' : '未登录' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="出口 IP" width="200">
          <template #default="scope">
            <div style="display:flex;align-items:center;gap:6px">
              <span v-if="scope.row.last_ip" style="font-family:monospace;font-size:12px">{{ scope.row.last_ip }}</span>
              <span v-else style="color:#909399;font-size:12px">未查询</span>
              <el-button
                size="small"
                text
                type="primary"
                :loading="checkingIpId === scope.row.id"
                @click="checkIp(scope.row)"
                title="查询该账号当前出口 IP（按代理配置）"
              >查IP</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template #default="scope">
            <el-button
              size="small"
              :type="scope.row.is_logged_in ? 'danger' : 'primary'"
              :loading="loggingInId === scope.row.id"
              @click="toggleLogin(scope.row)"
            >
              {{ scope.row.is_logged_in ? '退出' : '登录' }}
            </el-button>
            <el-button size="small" type="danger" @click="deleteAccount(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- Add Account Dialog -->
    <el-dialog v-model="showAddDialog" title="添加账号" width="500px">
      <el-form :model="newAccount" label-width="80px">
        <el-form-item label="平台">
          <el-radio-group v-model="newAccount.platform">
            <el-radio-button value="douyin">抖音</el-radio-button>
            <el-radio-button value="kuaishou">快手</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抖音号">
          <el-input v-model="newAccount.username" placeholder="抖音号（可稍后扫码补登）" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="newAccount.nickname" />
        </el-form-item>
        <el-form-item label="行业">
          <el-select v-model="newAccount.industry" filterable clearable placeholder="选行业（可稍后在列表点✏️补设）" style="width:100%">
            <el-option v-for="n in industries" :key="n" :label="n" :value="n" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showAddDialog = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="addAccount">确认</el-button>
      </template>
    </el-dialog>

    <!-- 账号登录弹窗（扫码 / 手机号+验证码 双通道） -->
    <el-dialog v-model="qrVisible" title="📱 账号登录" width="540px" :close-on-click-modal="false" :show-close="false">
      <el-tabs v-model="loginTab" stretch>
        <!-- Tab1 扫码登录 -->
        <el-tab-pane label="📷 扫码登录" name="qr">
          <div style="text-align:center">
            <div v-if="qrLoading" style="padding:40px 0;color:#909399">正在生成二维码...</div>
            <template v-else>
              <div class="qr-box">
                <img :src="qrUrl" class="qr-img" @error="qrImgError = true" @load="qrImgError = false" />
              </div>
              <div v-if="qrImgError" style="margin-top:-6px;padding-bottom:10px;color:#e6a23c;font-size:12px">二维码加载中…若长时间空白请点「刷新二维码」</div>
              <div style="margin-top:12px;font-size:13px;color:#606266;line-height:1.7">
                打开<b>手机抖音 App</b> → 左上角「扫一扫」→ 扫描上方二维码<br/>
                <span style="color:#909399">二维码约 1 分钟有效，超时自动刷新</span>
              </div>
              <el-button style="margin-top:10px" size="small" :loading="qrRefreshing" @click="refreshQr">🔄 刷新二维码</el-button>
            </template>
          </div>
        </el-tab-pane>
        <!-- Tab2 手机号+验证码登录 -->
        <el-tab-pane label="📲 手机号登录" name="sms" :disabled="isKuaishou">
          <div style="text-align:center;padding:6px 8px">
            <template v-if="smsState === 'idle'">
              <div style="font-size:13px;color:#606266;margin-bottom:16px;line-height:1.7">
                适用于不方便扫码的场景（如远程操作）。验证码将发送至
                <b>{{ smsPhone || '该账号绑定的' }}</b> 手机号短信。
              </div>
              <el-input v-model="smsPhone" class="sms-input" placeholder="请输入手机号（接收验证码）" maxlength="11" size="large" style="margin-bottom:14px" clearable />
              <div>
                <el-button type="primary" size="large" :loading="smsSending" @click="startSmsLogin">发送验证码</el-button>
                <el-button size="large" @click="switchQrTab">改用扫码登录</el-button>
              </div>
              <div style="margin-top:14px;font-size:12px;color:#909399">
                ⚠️ 若发送失败或长时间未收到，可能触发平台风控，建议使用扫码登录
              </div>
            </template>
            <template v-else-if="smsState === 'sms_wait_code' || smsState === 'sms_submitted'">
              <div style="font-size:13px;color:#606266;margin-bottom:14px;line-height:1.7">
                ✅ 验证码已发送至 <b>{{ smsPhone }}</b>，请查收手机短信
              </div>
              <el-input v-model="smsCode" class="sms-input sms-code" placeholder="请输入 6 位短信验证码" maxlength="6" size="large" style="margin-bottom:16px" clearable @keyup.enter="submitSmsCode">
                <template #prefix>🔢</template>
              </el-input>
              <div>
                <el-button type="primary" size="large" :loading="smsSubmitting" @click="submitSmsCode">提交并登录</el-button>
                <el-button size="large" @click="cancelQr">取消</el-button>
              </div>
              <div v-if="smsState === 'sms_submitted'" style="margin-top:12px;color:#e6a23c;font-size:12px">正在验证登录…请稍候</div>
              <div style="margin-top:10px;font-size:12px;color:#909399">
                若提示验证码错误可重新输入后再次提交；超过 4 分钟请重新发送
              </div>
            </template>
            <template v-else-if="smsState === 'sms_sending'">
              <div style="padding:24px 0;color:#909399">正在打开浏览器并发送验证码…</div>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
      <template #footer>
        <el-button @click="cancelQr">取消登录</el-button>
      </template>
    </el-dialog>

    <!-- 登录成功引导：绑定行业（一键打通截流+雷达，无需再开行业配置模块） -->
    <el-dialog v-model="guideVisible" title="🎯 给这个账号选个行业" width="480px" append-to-body>
      <div style="line-height:1.8;margin-bottom:14px;font-size:14px">
        为 <b>{{ guideAcc ? (guideAcc.nickname || guideAcc.username) : '' }}</b> 选择所属行业后，
        系统即按该行业自动：<b>截流打标、推送行业爆款雷达</b> —— 不用再单独打开「行业配置」。
      </div>
      <el-select v-model="guideIndustry" filterable placeholder="选择行业（可点跳过稍后设置）" style="width:100%">
        <el-option v-for="n in industries" :key="n" :label="n" :value="n" />
      </el-select>
      <template #footer>
        <el-button @click="guideVisible = false; guideAcc = null">跳过</el-button>
        <el-button type="primary" :loading="guideSaving" @click="saveGuideIndustry">保存并启用</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Accounts',
  data() {
    return {
      showAddDialog: false,
      saving: false,
      loading: false,
      loggingInId: null,
      checkingIpId: null,
      accounts: [],
      filterPlatform: '',
      newAccount: {
        username: '',
        nickname: '',
        platform: 'douyin',
        industry: ''
      },
      // 行业绑定（2026-09-04：账号管理内直接选行业，不用跳行业配置模块）
      industries: [],
      indEditingId: null,
      guideVisible: false,
      guideAcc: null,
      guideIndustry: '',
      guideSaving: false,
      pollTimer: null,
      qrVisible: false,
      qrAccountId: null,
      qrUrl: '',
      qrLoading: false,
      qrRefreshing: false,
      qrImgError: false,
      qrAccountPlatform: 'douyin',
      // 手机号+验证码登录
      loginTab: 'qr',
      smsPhone: '',
      smsCode: '',
      smsSending: false,
      smsSubmitting: false,
      smsState: 'idle'
    }
  },
  computed: {
    isKuaishou() {
      return this.qrAccountPlatform === 'kuaishou'
    },
  },
  created() {
    this.applyOnboardPrefill()
    this.loadAccounts()
    this.loadIndustries()
  },
  beforeUnmount() {
    if (this.pollTimer) clearInterval(this.pollTimer)
  },
  methods: {
    // 从「新手引导」页带过来的预选：平台 + 行业（localStorage onboard_state_v1）
    applyOnboardPrefill() {
      try {
        const q = new URLSearchParams(this.$route.query)
        if (q.get('platform')) this.newAccount.platform = q.get('platform')
        const s = JSON.parse(localStorage.getItem('gate_state_v1') || localStorage.getItem('onboard_state_v1') || 'null')
        if (s && s.industry) this.newAccount.industry = s.industry
      } catch (e) { /* 忽略 */ }
    },
    async loadIndustries() {
      try {
        const r = await api.get('/industries/')
        // v2 词库含 _ 前缀元数据键（_说明/_别名/_自采行业），兜底过滤掉
        this.industries = ((r && (r.names || [])) || []).filter(n => !String(n).startsWith('_'))
      } catch (e) {
        // 行业列表加载失败不阻塞页面
      }
    },
    async saveRowIndustry(row) {
      if (!row.industry) { this.indEditingId = null; return }
      try {
        await api.put(`/industries/accounts/${row.id}/industry`, { industry: row.industry })
        this.$message.success('行业已绑定：' + row.industry)
      } catch (e) {
        this.$message.error('保存失败: ' + (e.message || ''))
      } finally {
        this.indEditingId = null
      }
    },
    maybeGuideIndustry(accountId) {
      const me = this.accounts.find(a => a.id === accountId)
      if (me && !me.industry) {
        this.guideAcc = me
        this.guideIndustry = ''
        this.guideVisible = true
      }
    },
    async saveGuideIndustry() {
      if (!this.guideAcc) { this.guideVisible = false; return }
      if (!this.guideIndustry) { this.$message.warning('请选择一个行业，或点「跳过」'); return }
      this.guideSaving = true
      try {
        await api.put(`/industries/accounts/${this.guideAcc.id}/industry`, { industry: this.guideIndustry })
        const me = this.accounts.find(a => a.id === this.guideAcc.id)
        if (me) me.industry = this.guideIndustry
        this.$message.success('行业已绑定：' + this.guideIndustry + ' ✅ 截流与雷达将按此行业运行')
        this.guideVisible = false
        this.guideAcc = null
      } catch (e) {
        this.$message.error('保存失败: ' + (e.message || ''))
      } finally {
        this.guideSaving = false
      }
    },
    async loadAccounts() {
      this.loading = true
      try {
        const params = {}
        if (this.filterPlatform) params.platform = this.filterPlatform
        this.accounts = await api.get('/accounts/', { params })
      } catch (e) {
        this.$message.error('加载账号失败: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    platformText(p) {
      const map = { douyin: '抖音', kuaishou: '快手', xhs: '小红书' }
      return map[p] || p || '抖音'
    },
    getStatusType(status) {
      const map = {
        active: 'success',
        suspended: 'warning',
        banned: 'danger'
      }
      return map[status] || 'info'
    },
    statusText(status) {
      const map = {
        active: '正常',
        suspended: '受限',
        banned: '封禁'
      }
      return map[status] || status
    },
    async toggleLogin(account) {
      if (account.is_logged_in) {
        try {
          await api.post(`/accounts/${account.id}/logout`)
          account.is_logged_in = false
          this.$message.success('已退出登录')
        } catch (e) {
          this.$message.error('退出失败: ' + e.message)
        }
        return
      }
      // Start QR-scan login flow（二维码图片模式）
      this.loggingInId = account.id
      try {
        const r = await api.post(`/accounts/${account.id}/login`)
        // 打开登录弹窗（默认扫码 tab）
        this.qrAccountId = account.id
        this.qrAccountPlatform = account.platform || 'douyin'
        this.qrVisible = true
        this.qrLoading = true
        this.qrImgError = false
        this.qrUrl = ''
        this.loginTab = 'qr'
        this.smsState = 'idle'
        this.smsPhone = ''
        this.smsCode = ''
        this.loadQr()
        // poll login status
        if (this.pollTimer) clearInterval(this.pollTimer)
        this.pollTimer = setInterval(() => this.checkLoginStatus(account.id), 3000)
      } catch (e) {
        this.$message.error('启动登录失败: ' + e.message)
        this.loggingInId = null
      }
    },
    switchQrTab() {
      this.loginTab = 'qr'
    },
    async startSmsLogin() {
      if (!this.smsPhone || !/^1\d{10}$/.test(this.smsPhone)) {
        this.$message.warning('请输入正确的 11 位手机号')
        return
      }
      this.smsSending = true
      this.smsState = 'sms_sending'
      try {
        const r = await api.post(`/accounts/${this.qrAccountId}/sms-login`, { phone: this.smsPhone })
        if (r && r.started === false) {
          this.smsState = 'idle'
          this.$message.warning((r && r.message) || '已有登录流程进行中')
          return
        }
        // 状态由轮询推进：sms_sending → sms_wait_code → success/failed
        this.$message.success('验证码发送请求已提交，请留意手机短信')
      } catch (e) {
        this.smsState = 'idle'
        this.$message.error('发送验证码失败: ' + (e.message || ''))
      } finally {
        this.smsSending = false
      }
    },
    async submitSmsCode() {
      if (!this.smsCode || this.smsCode.length < 4) {
        this.$message.warning('请输入收到的短信验证码')
        return
      }
      this.smsSubmitting = true
      try {
        const r = await api.post(`/accounts/${this.qrAccountId}/sms-code`, { code: this.smsCode })
        if (r && r.ok) {
          this.smsState = 'sms_submitted'
          this.$message.success('验证码已提交，正在登录…')
        } else {
          this.$message.warning((r && r.message) || '提交失败，请重试')
        }
      } catch (e) {
        this.$message.error('提交验证码失败: ' + (e.message || ''))
      } finally {
        this.smsSubmitting = false
      }
    },
    async loadQr() {
      if (!this.qrAccountId) return
      try {
        const t = Date.now()
        this.qrUrl = `/api/v1/accounts/${this.qrAccountId}/login-qr?v=${t}`
        this.qrLoading = false
      } catch (e) {
        // 图片加载失败等下次轮询
      }
    },
    refreshQr() {
      this.qrRefreshing = true
      this.loadQr()
      setTimeout(() => { this.qrRefreshing = false }, 1000)
    },
    cancelQr() {
      this.qrVisible = false
      this.qrAccountId = null
      this.smsState = 'idle'
      if (this.pollTimer) { clearInterval(this.pollTimer); this.pollTimer = null }
      this.loggingInId = null
    },
    async checkLoginStatus(accountId) {
      try {
        const st = await api.get(`/accounts/${accountId}/login-status`)
        if (st.status === 'success') {
          clearInterval(this.pollTimer)
          this.pollTimer = null
          this.loggingInId = null
          this.qrVisible = false
          this.qrAccountId = null
          this.$message.success('🎉 登录成功，Cookie 已保存！')
          await this.loadAccounts()
          this.maybeGuideIndustry(accountId)
        } else if (st.status === 'failed') {
          clearInterval(this.pollTimer)
          this.pollTimer = null
          this.loggingInId = null
          this.qrVisible = false
          this.qrAccountId = null
          this.$message.error('登录失败: ' + (st.detail || '未知错误'))
        } else if (st.status === 'waiting_scan') {
          // 二维码已更新（约20s刷新一次）→ 前端跟随刷新
          this.loggingInId = null
          if (this.qrVisible) this.loadQr()
        } else if (st.status === 'sms_wait_code') {
          // 验证码已发出，等待用户填码
          this.loggingInId = null
          this.smsState = 'sms_wait_code'
        } else if (st.status === 'sms_submitted') {
          this.loggingInId = null
          this.smsState = 'sms_submitted'
        } else if (st.status === 'sms_sending') {
          this.loggingInId = null
          this.smsState = 'sms_sending'
        }
        // 兜底：DB 中账号已登录（可能由其他进程完成扫码）→ 关闭弹窗
        try {
          const accs = await api.get('/accounts/', { params: { platform: '' } })
          const list = Array.isArray(accs) ? accs : (accs.accounts || [])
          const me = list.find((x) => x.id === accountId)
          if (me && me.is_logged_in) {
            clearInterval(this.pollTimer)
            this.pollTimer = null
            this.loggingInId = null
            this.qrVisible = false
            this.qrAccountId = null
            this.$message.success('🎉 登录成功，Cookie 已保存！')
            await this.loadAccounts()
            this.maybeGuideIndustry(accountId)
          }
        } catch (e) { /* keep polling */ }
      } catch (e) {
        // transient, keep polling
      }
    },
    async checkIp(account) {
      this.checkingIpId = account.id
      try {
        const r = await api.post(`/accounts/${account.id}/check-ip`)
        if (r && r.success) {
          account.last_ip = r.ip
          const mode = r.via_proxy ? `代理出口（${r.proxy.replace(/^https?:\/\/[^@]*@/, '')}）` : '本机直连'
          this.$message.success(`出口 IP：${r.ip}（${mode}）`)
        } else {
          this.$message.error((r && r.detail) || 'IP 查询失败')
        }
      } catch (e) {
        this.$message.error('IP 查询失败: ' + e.message)
      } finally {
        this.checkingIpId = null
      }
    },
    deleteAccount(account) {
      this.$confirm(`确认删除账号 ${account.username}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await api.delete(`/accounts/${account.id}`)
          this.accounts = this.accounts.filter(a => a.id !== account.id)
          this.$message.success('删除成功')
        } catch (e) {
          this.$message.error('删除失败: ' + e.message)
        }
      }).catch(() => {})
    },
    async addAccount() {
      if (!this.newAccount.username) {
        this.$message.warning('请输入抖音号')
        return
      }
      this.saving = true
      const chosen = this.newAccount.industry || ''
      try {
        const acc = await api.post('/accounts/', {
          username: this.newAccount.username,
          nickname: this.newAccount.nickname,
          platform: this.newAccount.platform
        })
        // 行业字段走行业接口（账号创建接口不接收行业）
        if (chosen && acc && acc.id) {
          await api.put(`/industries/accounts/${acc.id}/industry`, { industry: chosen })
          acc.industry = chosen
        }
        this.accounts.push(acc)
        this.showAddDialog = false
        this.newAccount = { username: '', nickname: '', platform: 'douyin', industry: '' }
        this.$message.success(chosen ? '添加成功，行业已绑定：' + chosen : '添加成功（可点行业列 ✏️ 绑定行业）')
      } catch (e) {
        this.$message.error('添加失败: ' + e.message)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.accounts {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.qr-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, .06);
  line-height: 0;
  width: min(372px, 74vw);
  height: min(372px, 74vw);
  box-sizing: border-box;
}
.qr-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.sms-input {
  width: 100%;
  max-width: 330px;
  margin-left: auto;
  margin-right: auto;
}
.sms-code {
  max-width: 300px;
}
</style>
